import { QueryClient } from 'react-query';

export const appQueryClient = new QueryClient();
